/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-02-16 08:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getFormValues, reset, FieldArray, Field, change } from 'redux-form';

import PinProductsTable from 'src/components/views/merchandising-v2/rule/strategy/pin-products/pin-products-table';
import { RenderCheckboxToolTip } from 'src/components/views/common/forms/render-checkbox-tooltip';

import { buildInitialPinValues } from 'src/helpers/merchandising-v2-helper';
type Props = {
  active: boolean
};

type ComposedProps = Props & WithI18nProps;

class PinProductsModal extends Component<ComposedProps> {
  componentDidMount() {
    const { strategies = [], updateField, ruleType } = this.props;
    const indexPinValue = strategies.findIndex(e => e.type === 'pin');
    if (indexPinValue === -1) {
      const clonedStrategies = _.cloneDeep(strategies);
      const pinValue = buildInitialPinValues(null, indexPinValue, ruleType);
      clonedStrategies.push(pinValue);
      updateField('strategies', clonedStrategies);
    }
  }
  render() {
    const { i18n, pinPositions, indexPinValue, ruleType } = this.props;

    return (
      <FormLayout>
        {ruleType === 'search' && (
          <div>
            <Field
              name={`strategies[${indexPinValue}].pinMatchRequired`}
              component={RenderCheckboxToolTip}
              label={i18n.translate(
                'AdminHTML.MerchandisingV2.PinProductsModal.pinMatchRequired_Label'
              )}
              tooltip={i18n.translate(
                'AdminHTML.MerchandisingV2.PinProductsModal.pinMatchRequired_Tooltip'
              )}
            />
          </div>
        )}
        <FieldArray
          name={`strategies[${indexPinValue}].pinPositions`}
          component={PinProductsTable}
          pinPositions={pinPositions}
        />
      </FormLayout>
    );
  }
}

const mapStateToProps = (state, props) => {
  const formValues = getFormValues('MerchandisingV2RuleForm')(state);
  const strategies = _.get(formValues, 'strategies', []);
  const pinValue = strategies.find(e => e.type === 'pin');
  const indexPinValue = strategies.findIndex(e => e.type === 'pin');
  return {
    strategies,
    indexPinValue,
    pinPositions: _.get(pinValue, 'pinPositions', [{}, {}, {}, {}, {}, {}, {}])
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  resetForm: () => dispatch(reset('MerchandisingV2RuleForm')),
  // Update redux-form field
  updateField: (field, value) => dispatch(change(`MerchandisingV2RuleForm`, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(PinProductsModal));
